// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'Products/';
export const ProductActionTypes = {
  PRODUCT_BROWSER: ActionHelper.createActionTypes(
    actionTypePrefix,
    'PRODUCT_BROWSER'
  ),
  PRODUCT_DETAILS: ActionHelper.createActionTypes(
    actionTypePrefix,
    'PRODUCT_DETAILS'
  ),
  PRODUCT_FILTERS: {
    INITIALIZE: `${actionTypePrefix}/PRODUCT_FILTERS_INITIALIZE`,
    TOGGLE_FILTER: `${actionTypePrefix}/PRODUCT_FILTERS_TOGGLE_FILTER`,
    CLEAR_FILTERS: `${actionTypePrefix}/PRODUCT_FILTERS_CLEAR_FILTERS`,
  },
};
